import { ReactElement } from 'react';
import { Button, Typography } from '@mui/material';
import Loader from '../components/common/Loader';
import logo from '../images/Logo_GLYNT_2020.png';
import { useAuth0 } from '@auth0/auth0-react';
import { useSetTitle } from '../components/hooks/useSetTitle';
import { useTheme } from '@mui/material/styles';

export default function WelcomePage(): ReactElement {
  const { loginWithPopup, isLoading } = useAuth0();
  const theme = useTheme();

  useSetTitle('Login');

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ flex: 1 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '2em',
          }}
        >
          <img src={logo} alt="logo" width={300} />
        </div>

        <Typography variant="h4" align="center">
          Transform Documents into Data
        </Typography>
        <div
          style={{
            margin: '1em 0',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: theme.palette.primary.main }}
            // disabled={popupOpen}
            data-cy="btn-login"
            onClick={async () => {
              await loginWithPopup();
            }}
          >
            Login
          </Button>
        </div>
      </div>
      <Typography align="center">&copy; {new Date().getFullYear()} Glynt</Typography>
    </div>
  );
}
